import React from "react";
import { Table, Divider, Input, Button, Tooltip } from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  EditOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import {
  ServiceInstanceActions,
  ServiceInstanceMaturityState,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../Constants/Constants";
import { StatusSwitch } from "../Common/StatusSwitch";
import {
  createFilter,
  defaultSort,
  getTablePagesize,
  setTablePageSize,
} from "../../Constants/Utilities";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ListServiceInstance extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListServiceInstance props", props);
    this.state = {
      instanceData: props.instanceData,
    };
  }

  getColumns = () => [
    {
      title: "Instance Name",
      dataIndex: "name",
      sorter: (a, b) => defaultSort(a.name, b.name),
      defaultSortOrder: "ascend",
      width: 250,
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(
            ServiceInstanceActions.view,
            record
          )}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Maturity State",
      dataIndex: "maturity",
      filters: createFilter(ServiceInstanceMaturityState),
      onFilter: (value, record) => record.maturity === value,
      sorter: (a, b) => defaultSort(a.maturity, b.maturity),
      width: 120,
    },
    {
      title: "Version",
      dataIndex: "version",
      sorter: (a, b) => defaultSort(a.version, b.version),
      width: 80,
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      width: 60,
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      width: 20,
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Instance">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(
                ServiceInstanceActions.view,
                record
              )}
            />
          </Tooltip>
          <Tooltip title="Edit Instance">
            <EditOutlined
              className="entity-action"
              onClick={this.props.onActionClick(
                ServiceInstanceActions.edit,
                record
              )}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  componentDidUpdate(prevProps) {
    if (prevProps.instanceData !== this.props.instanceData) {
      this.setState({ instanceData: this.props.instanceData });
    }
  }

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { instanceData } = this.props;
    if (!!text) {
      const filteredData = instanceData.filter((item) =>
        item.name.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ instanceData: filteredData });
      return;
    }
    this.setState({ instanceData });
  };

  render() {
    const { instanceData } = this.state;
    const {
      instanceDataLoading,
      onActionClick,
      onParentActionClick,
      parentBread,
    } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread}
            onParentActionClick={onParentActionClick(null, null)}
          />
        </div>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Instance Name"
              onChange={this.onSerchTextChange}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ServiceInstanceActions.add, null)}
            >
              Add Service Instance
            </Button>
          </div>
        </div>
        <Table
          bordered
          size="small"
          columns={this.getColumns()}
          className="entity-table"
          loading={instanceDataLoading && { tip: "Fetching Instnace list..." }}
          dataSource={instanceData}
          pagination={{
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            defaultPageSize: getTablePagesize(TablePages.listServiceInstance),
            pageSizeOptions: TablePageSizes,
            onChange: (_, pageSize) =>
              setTablePageSize(TablePages.listServiceInstance, pageSize),
          }}
        />
      </div>
    );
  }
}

export default ListServiceInstance;
